import { render, staticRenderFns } from "./ProrrogarVigenciaDialog.vue?vue&type=template&id=99967b70"
import script from "./ProrrogarVigenciaDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProrrogarVigenciaDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports